export interface SportAccent {
  primary: string;
  bg: string;
  border: string;
  glow: string;
  label: string;
  emoji: string;
}

export const SPORT_ACCENTS: Record<string, SportAccent> = {
  mlb:  { primary: 'text-brand',         bg: 'bg-brand/15',   border: 'border-brand/25',   glow: 'shadow-brand/20',   label: 'MLB',  emoji: '⚾' },
  wnba: { primary: 'text-purple-bright', bg: 'bg-purple/15',  border: 'border-purple/25',  glow: 'shadow-purple/20',  label: 'WNBA', emoji: '🏀' },
  nba:  { primary: 'text-orange-400',    bg: 'bg-orange-500/15', border: 'border-orange-500/25', glow: 'shadow-orange-500/20', label: 'NBA', emoji: '🏀' },
  nfl:  { primary: 'text-win',           bg: 'bg-win/15',     border: 'border-win/25',     glow: 'shadow-win/20',     label: 'NFL',  emoji: '🏈' },
  nhl:  { primary: 'text-info',          bg: 'bg-info/15',    border: 'border-info/25',    glow: 'shadow-info/20',    label: 'NHL',  emoji: '🏒' },
};

export const SUB_PRODUCT_LABELS: Record<string, string> = {
  diamondedge: 'DiamondEdge',
  courtedge:   'CourtEdge',
  gridironedge: 'GridironEdge',
  iceedge:     'IceEdge',
  pitchedge:   'PitchEdge',
};

export function getSportAccent(leagueId?: string): SportAccent {
  return SPORT_ACCENTS[leagueId?.toLowerCase() ?? ''] ?? {
    primary: 'text-gray-400',
    bg: 'bg-surface-3',
    border: 'border-surface-4',
    glow: 'shadow-none',
    label: leagueId?.toUpperCase() ?? '?',
    emoji: '🏅',
  };
}
